import { Box } from '@mui/material'
import React from 'react'
import { ExtensionStates, ExtensionTypes, LuoxEnergySvg, OStromSvg, TibberSvg } from 'src/Libs/installation-extensions'
import { extensionColors } from 'src/Libs/installation-extensions/colors'
import { InstallationExtensionsModel } from 'src/Libs/installation-extensions/models/installation-extensions.model'

interface Props {
  installationExtensionsState: InstallationExtensionsModel[]
}

/**
 * This component shows the Extension image based on the active Extension.
 */
const ExtensionsImage: React.FC<Props> = ({ installationExtensionsState }) => {
  const activeExtensions = installationExtensionsState.filter(extension => extension.state === ExtensionStates.Active)
  const isActiveExtensionOstrom = activeExtensions.some(extension => extension.extension === ExtensionTypes.OStrom)
  const isActiveExtensionTibber = activeExtensions.some(extension => extension.extension === ExtensionTypes.Tibber)
  const isActiveExtensionLuoxDynamicPrices = activeExtensions.some(extension => extension.extension === ExtensionTypes.LuoxTwo)

  if (isActiveExtensionOstrom)
    return (
      <StyledContent>
        <OStromSvg textFill={extensionColors.ostrom.primary} />
      </StyledContent>
    )

  if (isActiveExtensionTibber)
    return (
      <StyledContent>
        <TibberSvg fill={extensionColors.tibber.primary} textFill={extensionColors.tibber.primary} />
      </StyledContent>
    )

  if (isActiveExtensionLuoxDynamicPrices)
    return (
      <StyledContent>
        <LuoxEnergySvg />
      </StyledContent>
    )

  return <></>
}

interface StyledContentProps {
  children: React.ReactNode
}

const StyledContent: React.FC<StyledContentProps> = ({ children }) => {
  return <Box sx={{ height: 24 }}>{children}</Box>
}

export default ExtensionsImage
